export default __webpack_public_path__ + "static/media/FallsReferralv6.2220510FallsReferralguidanceandflowchartv6_2_flowchart.104bfe83.jpg";